import ShopServiceModel   from '@/models/ShopServiceModel';
import doc                from '@widesk-core/decorators/doc';
import model              from '@widesk-core/decorators/model';

export type DeliverableTransferStatusReference = 'waiting' | 'accepted' | 'canceled' | 'refused';

@model.urnResource('deliverable_transfer_status')
@doc.path('/deliverable_transfer_statuses/{?id}')
export default class DeliverableTransferStatusModel extends ShopServiceModel {
	private declare _tsFilters: {
		'reference': DeliverableTransferStatusReference;
	};

	private declare _tsSorts: {
		'id': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: DeliverableTransferStatusReference;

	public get color() {
		switch (this.reference) {
			case 'refused':
				return 'red';
			case 'canceled':
				return 'red';
			case 'accepted':
				return 'green';
			case 'waiting':
				return 'blue';
		}
	}
}